import { useEffect, useState } from "react";
import AudioUploaderV2 from "../../../../components/forms/AudioUploader/AudioUploaderV2";
import TabbedPanel from "../../../../components/TabbedPanel/TabbedPanel";
import DEBUG_LOGGER from "../../../../helpers/DebugLogger";
import { convertUniqueFilenameToOriginal, getCampaignAudio, getCampaignVideos } from "../../../../components/v2/CustomisationWorkspace/v2IntegrationHelpers/CampaignAndFeatureDataHelperFunctions";
import { IconJsxer } from "../../../../helpers/IconHelper";
import WaveSurfer from "wavesurfer.js";
import VideoUploaderV2 from "../../../../components/forms/VideoUploader/VideoUploaderV2";

const VideoUploaderContent = (props) => {
    const varVal = props.videoFileData;
    const [videoSrc, setVideoSrc] = useState(varVal?.srcUrl || "");

    const [busy, setBusy] = useState(false);
    const [campaignVideo, setCampaignVideo] = useState([]);
    const [loadingVideo, setLoadingVideo] = useState(false);
    const handleLibraryVideoSelect = (videoFileData) => {
        if (!busy && props.isOpenCanMakeChanges) {
            varVal.srcUrl = videoFileData.url;
            setVideoSrc(videoFileData.url);
            varVal.originalFile = videoFileData.filename;
            varVal.filename = videoFileData.filename;
            varVal.newFile = null;
            varVal.isDefault = false;

            // Trigger both callbacks to update UI and right sidebar preview
            if (props.onVideoSelected) {
                props.onVideoSelected(varVal);
            }
            if (props.onVideoChanged) {
                props.onVideoChanged(varVal);
            }
        }
    };

    const [currentTab, setCurrentTab] = useState('upload');

    // Load campaign video when switching to library tab
    useEffect(() => {
        const loadCampaignVideo = async () => {
            if (currentTab === 'library' && props.campaignData?._id && campaignVideo.length === 0 && !loadingVideo) {
                setLoadingVideo(true);
                try {
                    const video = await getCampaignVideos(props.campaignData._id);
                    setCampaignVideo(video);
                } catch (error) {
                    DEBUG_LOGGER.error('Failed to load campaign video:', error);
                } finally {
                    setLoadingVideo(false);
                }
            }
        };
        loadCampaignVideo();
    }, [currentTab, props.campaignData?._id, campaignVideo.length, loadingVideo]);

    const handleTabSwitch = (tabId, tabData) => {
        setCurrentTab(tabData.id);
    };

    const tabData = [
        { label: 'Upload New', id: 'upload' },
        { label: 'Video Library', id: 'library' }
    ];

    const renderLibraryTab = () => (
        <div className="library-tab-content" onWheel={(e) => e.stopPropagation()}>
            {loadingVideo ? (
                <div className="loading-message">Loading campaign video...</div>
            ) : campaignVideo.length === 0 ? (
                <div className="no-items-message">
                    No video files found in this campaign.
                    <br />Upload some video using the "Upload New" tab.
                </div>
            ) : (
                <div className="campaign-items-grid">
                    {campaignVideo.map((video, index) => (
                        <div 
                            key={index} 
                            className={`campaign-library-item${varVal?.filename === video.filename ? ' selected' : ''}`}
                            onClick={() => handleLibraryVideoSelect(video)}
                        >
                            <div className="fl-column grow compact">
                                <div className="item-name">{convertUniqueFilenameToOriginal(video.name)}</div>
                                <div className={`video-preview-holder`}>
                                    <video width={198} height={110} controls>
                                        <source src={video?.url} />
                                    </video>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Show selected image details */}
            {varVal && currentTab === 'library' && (
                <div className="selected-item-info">
                    <div className="file-name">Selected: {convertUniqueFilenameToOriginal(varVal.originalFile)}</div>
                </div>
            )}
        </div>
    );

    return (
        <TabbedPanel
            tabs={tabData}
            switchTabCallback={handleTabSwitch}
            initialTab={0}
            tabWidth="100%"
            tabStyle={2}
        >
            <>
                {currentTab === 'upload' &&
                    <VideoUploaderV2
                        id={"temporary-video-upload"}
                        currentFile={varVal?.srcUrl || ""}
                        currentFileName={varVal.originalFile || "Unknown"}
                        fileData={varVal}
                        fileSelectedCallback={
                            (data) => { 
                                console.log('TemporaryVideoUploadPopup fileSelectedCallback', data);
                                if (data.originalEvent !== 'removed') {
                                    const fileData = data.file;
                                    // Create a blob url for the uploaded file
                                    const blobUrl = URL.createObjectURL(fileData);
                                    varVal.srcUrl = blobUrl;
                                    varVal.newFile = fileData;
                                    varVal.originalFile = fileData.name;
                                    varVal.isDefault = false;
                                    varVal.filename = fileData.name;
                                    // That's all we need to do here as we are not going to actually upload this image now, we will handle it properly later
                                    // (this is only a temporary image upload and we are not saving our data yet)

                                    // Trigger both callbacks to update UI and right sidebar preview
                                    if (props.onVideoSelected) {
                                        props.onVideoSelected(varVal);
                                    }
                                    if (props.onVideoChanged) {
                                        props.onVideoChanged(varVal);
                                    }
                                }
                            }
                        }
                        showRemoveOption={false}
                        uploadImmediately={false}
                        showLabel={true}
                        label={props.controlLabel}
                        labelNote={props.labelNote}
                    />
                }
                {currentTab === 'library' && renderLibraryTab()}
            </>
        </TabbedPanel>
    );
}

export default VideoUploaderContent;